import React, { useState, useEffect, useRef } from 'react'
// import { Link } from 'react-router-dom'
import { Form, Button, Row, Col } from 'react-bootstrap'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate, Link } from 'react-router-dom'
import Message from '../components/Message.js'
import Loader from '../components/Loader.js'
import { register } from '../actions/adminActions.js'
import { listUsers } from '../actions/userActions.js'
import FormContainer from '../components/FormContainer.js'
import { ADMIN_REGISTER_USER_RESET } from '../constants/adminConstants.js'

const AdminRegister = () => {
  const [name, setName] = useState('')
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const [confirmPassword, setConfirmPassword] = useState('')
  const [isAdmin, setIsAdmin] = useState(false)
  const [isDisabled, setIsDisabled] = useState(false)
  const [message, setMessage] = useState(null)

  const dispatch = useDispatch()
  const navigate = useNavigate()
  const inputRef = useRef()

  const adminRegister = useSelector((state) => state.adminRegister)
  const { loading, error, adminUser, success } = adminRegister

  const userLogin = useSelector((state) => state.userLogin)
  const { userInfo } = userLogin

  useEffect(() => {
    if (adminUser && !loading) {
      dispatch({ type: ADMIN_REGISTER_USER_RESET })
      navigate('/admin/userlist')
    } else {
      dispatch({ type: ADMIN_REGISTER_USER_RESET })
      inputRef.current.focus()
    }
  }, [navigate, adminUser, dispatch, loading, success])

  const submitHandler = (e) => {
    e.preventDefault()

    if (password !== confirmPassword) {
      setMessage('Passwords do not match')
    } else {
      const cid = userInfo.cid
      dispatch(register(name, email, password, isAdmin, isDisabled, cid))
      dispatch(listUsers())
    }
  }

  return (
    <FormContainer>
      <Row className='my-3'>
        <Col>
          <h3 className='my-2'>User Register</h3>
        </Col>
        <Col className='text-right'>
          <Link to='/admin/userlist' className='btn btn-info btn-sm my-2'>
            Go Back
          </Link>
        </Col>
      </Row>

      {message && <Message variant='danger'>{message}</Message>}
      {error && <Message variant='danger'>{error}</Message>}
      {loading && <Loader />}

      <Form onSubmit={submitHandler}>
        <Form.Group className='mb-2' controlId='name'>
          <Form.Label>Name</Form.Label>
          <Form.Control
            ref={inputRef}
            type='name'
            autoFocus
            placeholder='Enter Name'
            value={name}
            onChange={(e) => setName(e.target.value)}
          />
        </Form.Group>
        <Form.Group className='mb-2' controlId='email'>
          <Form.Label>Email Address</Form.Label>
          <Form.Control
            type='email'
            placeholder='Enter email'
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
        </Form.Group>
        <Form.Group className='mb-2' controlId='password'>
          <Form.Label>Password</Form.Label>
          <Form.Control
            type='password'
            placeholder='Enter Password (minimum 6 characters)'
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />
        </Form.Group>
        <Form.Group className='mb-2' controlId='confirmPassword'>
          <Form.Label>Confirm Password</Form.Label>
          <Form.Control
            type='password'
            placeholder='Confirm Password (minimum 6 characters)'
            value={confirmPassword}
            onChange={(e) => setConfirmPassword(e.target.value)}
          />
        </Form.Group>
        <Form.Group className='mb-2' controlId='isadmin'>
          <Form.Check
            type='checkbox'
            label='Is Admin'
            checked={isAdmin}
            onChange={(e) => setIsAdmin(e.target.checked)}
          ></Form.Check>
        </Form.Group>
        <Form.Group className='mb-2' controlId='isdisabled'>
          <Form.Check
            type='checkbox'
            label='Is Disabled'
            checked={isDisabled}
            onChange={(e) => setIsDisabled(e.target.checked)}
          ></Form.Check>
        </Form.Group>

        <Button type='submit' className='btn btn-dark'>
          Register User
        </Button>
      </Form>
    </FormContainer>
  )
}

export default AdminRegister
